<template>
    <div>
        <div class="card survey" style="width: 60rem;">
            <ul class="list-group list-group-flush">
                <li class="list-group-item survey" v-for="(survey, index) in surveys">
                    <h5 class="card-title">{{surveys[index]['question']}}</h5>
                    <div>
                        <a href="#" class="btn btn-secondary icon mb-1"
                           v-for="score in Number(surveys[index]['highest_score'])"
                           v-on:click="buildData(index, survey, score, $event)"
                           :id="'score_' + score"
                           :ref="score"
                           :class="{isActive:false}"
                            >
                            {{score}}
                        </a>
                    </div>
                    <div class="form-group">
                        <label for="comment">{{ $t('survey.commentText') }}</label>
                        <textarea class="form-control" id="comment" v-model="comments[index]" rows="3"></textarea>
                    </div>
                </li>
            </ul>

            <div class="card-body">
                <a href="#" class="btn btn-primary" v-on:click="submitSurvey(comments)">
                    {{ $t('survey.buttonText') }}
                </a>
                <i class="fa fa-spinner fa-spin" style="font-size:24px" v-if="showSpinner"></i>
            </div>
        </div>

    </div>
</template>

<script>
    import Qs from 'qs';

    let data = [];
    export default {
        name: 'survey-csat-view',
        props: ['surveys'],
        data() {
            return {
                comments: [],
                lastActiveRef: null,
                showSpinner: false
            }
        },
        methods: {
            buildData(index, survey, customerScore, e) {
                e.stopPropagation();

                if (this.lastActiveRef !== null) {
                    this.$refs[this.lastActiveRef][0].classList.toggle('isActive')
                }

                this.$refs[customerScore][0].classList.toggle('isActive');
                this.lastActiveRef = customerScore;

                survey['response'] = customerScore;
                data[index] = survey;
            },
            submitSurvey(comments) {
                if (!Array.isArray(data) || !data.length > 0) {
                    alert('Please complete the survey before submitting');
                    return;
                }
                if (Array.isArray(comments) && comments.length > 0) {
                    comments.forEach((comment, index) => {
                        data[index]['comment'] = comment;
                    });
                }

                //show spinner
                this.showSpinner = true;
                let url = window.env.baseUri + 'survey/save-survey-response';
                return axios.post(url,  Qs.stringify(data)).then((response) => {
                    if (response.data.result === true) {
                        window.location.replace(window.env.baseUri + "survey/thanks");
                    } else {
                        this.showSpinner = false;
                        alert(response.data.feedback_message)
                    }
                });
            },
        }
    };
</script>

<style scoped>
.survey {
    background-color: #f8f9fa;
}

a {
    margin: 3px;
}

.card-title {
    font: bold 22px Verdana, Courier, sans-serif;
}

.form-group {
    padding-top: 40px;
    font: italic 20px Verdana, Courier, sans-serif;
    margin-left: 60px;
    margin-right: 60px;
}

.btn-secondary:hover {
    background-color: #0b7fb3;
}
.isActive {
    background-color: #0b7fb3;
}
    
</style>